<template>
  <div >
      <h1 class="is-size-3"><small class="has-text-weight-bold">Edição de Curso #{{$route.params.curso}}</small> </h1>
        <br />
        <el-button-group>
          <el-button :type="isActive('conteudos')" @click='openLink("conteudos")'> Conteúdos</el-button>
          <el-button :type="isActive('planos')" @click='openLink("planos")'> Planos</el-button>
          <el-button :type="isActive('inscritos')" @click='openLink("inscritos")'> Inscritos</el-button>
          <el-button :type="isActive('pendentes')" @click='openLink("pendentes")'> Pendentes</el-button>
          <!--<el-button :type="isActive('estatisticas')" @click='openLink("estatisticas")'> Estatísticas</el-button>-->
        </el-button-group>
      <hr />
    </div>
</template>

<script>
  export default {
    data(){
      return {
        curso: '',
      }
    },
    methods: {
      isActive(p){
        const splited = this.$route.path.split("/");
        this.curso = this.$route.params.curso;
        const num = splited.length;
        const path = splited[num-1];
        if(p==path)
          return 'info';
        else
          return 'default'
      },
      openLink(link){
        this.$router.push(`/admin/curso/${this.curso}/${link}`)
      },
    }
  };
</script>

<style>

</style>